'use client';

import { PropsWithChildren, useContext } from 'react';
import { FieldError, get, useFormContext } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';

import { PropsWithClasses } from '@lamesarv-sdk/types';

import { CommonFormContext } from '.';

interface ICommonCheckboxProps extends PropsWithChildren, PropsWithClasses {
  name: string;
  isRequired?: boolean;
  classContainer?: string;
}

export const CommonCheckbox = (props: PropsWithChildren<ICommonCheckboxProps>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const { isDisabled } = useContext(CommonFormContext);

  const error = get(errors, props.name) as FieldError | null;

  return (
    <div className={twMerge('flex flex-col gap-1.5 group', props.classContainer)}>
      <div className={twMerge('flex flex-row items-center gap-2', props.className)}>
        <input
          type="checkbox"
          {...register(props.name)}
          className={twMerge(
            'border border-black-350 size-3 disabled:opacity-60',
            props.classInput,
            error && 'border-red-700',
          )}
          required={props.isRequired}
          disabled={isDisabled}
        />
        <span className="text-sm text-black-500">{props.children}</span>
        {props.isRequired && <span className="text-red-700 leading-none"> *</span>}
      </div>
      {error && <span className="text-red-700 text-sm">{error.message}</span>}
    </div>
  );
};
